//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionBuilder.js";
import "../Motion/Motion.SelectFieldData.js";
import "../Motion/Motion.LinkCouplerCoupleBuilder.js";
import "../no/SelectObject.js";
let d=[[[0,"Curve",1,"Motion.MotionFunction",0],[1,"CurveProfile",0,"Motion.SelectFieldData",0],[0,"CurveType",1,0],[1,"FirstCouple",0,"Motion.LinkCouplerCoupleBuilder",0],[0,"Method",1,0],[0,"Name",1,0],[1,"SecondCouple",0,"Motion.LinkCouplerCoupleBuilder",0],[0,"Type",1,0]],[],[]];
SPLM.Motion.LinkCouplerBuilder = class extends SPLM.Motion.MotionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.LinkCouplerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.LinkCouplerBuilder.TypeChoices = Object.freeze({
    "TwoLink" : "TwoLink", "ThreeLink" : "ThreeLink", "FourLink" : "FourLink"});

SPLM.Motion.LinkCouplerBuilder.MethodChoices = Object.freeze({
    "Scales" : "Scales", "CouplingCurve" : "CouplingCurve"});

SPLM.Motion.LinkCouplerBuilder.CurveChoices = Object.freeze({
    "Function" : "Function", "Profile" : "Profile"});

export default SPLM;